import React from 'react';
import FromServer from './FromServer';
import { Divider, Grid, Checkbox } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import LocalStorage from '../../providers/LocalStorage';
import DocumenteList from '../../commons/DocumenteList';
import Utils from '../../providers/Utils';
import AlertDialog from '../../commons/dialogs/AlertDialog';
import CustomAppBar from '../../commons/AppBar';
import wordIcon from '../../Pics/word_icon.png'
import pdfIcon from '../../Pics/pdf.png'
import DrepturiAcces from '../drepturiacces/DrepturiAcces';
import AlertNew from '../../commons/dialogs/AlertNew';

export default class Economic extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listDocumente: [],
            objFile: {},
            isOpenAlert: false,
            proiecteCheck: false,
            etapeCheck: false,
            taskuriCheck: false,
            listFiltered: [],
            filterBy: [],
            fullScreen: false,
            listAllDocs: [],
            proiecteDocs: 0,
            proiecte: [],
            alertView: false
        }
    }

    //'Upload/DocTask'

    // adresaMedia/Proiecte/Docs

    // adresaMedia/Taskuri/Docs
    drepturiAcces = new DrepturiAcces()
    drepturiP = new DrepturiAcces()

    componentDidMount() {
        // this.getDocumente()
        // this.getWindowDimentions()
        this.getProiecte()
    }

    ws = new Ws()

    fs = new FromServer()

    ls = new LocalStorage()

    getProiecte = async () => {

        let _proiecte = this.ws.customSelect('select * from proiecte where isnull(sters,0) = @p1 order by id desc', {
            p1: 0
        })

        let _getDocumente = this.fs.getDocumente()

        let _documenteTaskuri = this.ws.customSelect('select d.*, t.titlu as nume_t  from taskuri_documente d left join taskuri t on d.id_task = t.id where  isnull(d.sters,0) !=1 ', {
            p1: 0
        })

        let _documenteEtape = this.ws.customSelect('select d.*, e.denumire as nume_t from etape_documente d left join proiecte_etape e on d.id_etapa = e.id  where isnull(sters,0) != 1', {
            p1: 0
        })


        let _getBugetProiect = this.ws.customSelect('select * from proiecte_bugete ', {
            p1: 0
        })

        let _getBugetEtapa = this.ws.customSelect(`select b.*, p.id as id_proiect from bugete_etape b left join proiecte p
                                on b.id_etapa in (select id from proiecte_etape where id_proiect = p.id and isnull(inactiv,0) != 1 )  and isnull(b.sters,0) != 1` , {
            p1: 0
        })

        let _getBugetTask = this.ws.customSelect(`select b.*, p.id as id_proiect from bugete_taskuri b left join proiecte p
                                                    on b.id_task in (select id from taskuri where id_proiect = p.id and isnull(inactiv,0) != 1) and isnull(b.sters,0) != 1 `, {
            p1: 0
        })

        // let _getBugetTask = this.ws.customSelect('select * from taskuri' , {
        //     p1:0
        // })


        let _getCostEtapa = this.ws.customSelect(`select b.*, p.id as id_proiect from costuri_etape b left join proiecte p
          on b.id_etapa in (select id from proiecte_etape where id_proiect = p.id and isnull(inactiv,0) != 1 )  and isnull(b.sters,0) != 1` , {
            p1: 0
        })


        let _getCostTask = this.ws.customSelect(`select ct.*, p.id as id_proiect from costuri_taskuri ct left join proiecte p
          on ct.id_task in (select id from taskuri where id_proiect = p.id and isnull(inactiv,0) != 1) and isnull(ct.sters,0 ) != 1 `, {
            p1: 0
        })

        let _utilizatori = await this.ws.customSelect(`select d.id_proiect, d.id as id_linie, d.doar_citire, d.nivel_responsabil, d.drepturi_extinse, d.id_utilizator as id ,
        a.nume, a.poza, a.cost_minut, u.email, u.firma, a.id as id_angajat, dep.nume as nume_departament from proiecte_drepturi d left join useri u on d.id_utilizator = u.id
        left join angajati a on u.id = a.id_user 
        left join angajati_departamente ad on ad.id_angajat = a.id
        left join departamente dep on dep.id = ad.id_departament
        where isnull(u.inactiv,0) != 1 and isnull(d.sters,0) != 1 order by isnull(d.nivel_responsabil,3) asc`, {
            p1: ''
        })

        let [proiecte, getDocumente, documenteTaskuri, documenteEtape, getBugetProiect, getBugetEtapa, getBugetTask, getCostEtapa, getCostTask, utilizatori] =
            await Promise.all([_proiecte, _getDocumente, _documenteTaskuri, _documenteEtape, _getBugetProiect, _getBugetEtapa, _getBugetTask, _getCostEtapa, _getCostTask, _utilizatori])


        console.log('proiecte :>> ', proiecte);
        console.log('getDocumente :>> ', getDocumente);
        console.log('documenteTaskuri :>> ', documenteTaskuri);
        console.log('documenteEtape :>> ', documenteEtape);
        console.log('getBugetProiect :>> ', getBugetProiect);
        console.log('getBugetEtapa :>> ', getBugetEtapa);
        console.log('getBugettask :>> ', getBugetTask);
        console.log('getCostEtapa :>> ', getCostEtapa);
        console.log('getCostTask :>> ', getCostTask);

        if (proiecte.Succes &&
            getDocumente.Succes &&
            documenteTaskuri.Succes &&
            documenteEtape.Succes &&
            getBugetProiect.Succes &&
            getBugetEtapa.Succes &&
            getBugetTask.Succes &&
            getCostEtapa.Succes &&
            getCostTask.Succes &&
            utilizatori.Succes
        ) {

            let proiecte2 = [...proiecte.Content]
            let cloneProiecte = []
            let cloneUseri = [...utilizatori.Content]
            let documenteNr = getDocumente.Content.length + documenteTaskuri.Content.length + documenteEtape.Content.length



            for (let i = 0, n = proiecte2.length; i < n; i++) {

                let buget = 0

                let docProiect = [...getDocumente.Content].filter(dP => dP.id_proiect === proiecte2[i].id).length +
                    [...documenteEtape.Content].filter(dE => dE.id_proiect === proiecte2[i].id).length +
                    [...documenteTaskuri.Content].filter(dT => dT.id_proiect === proiecte2[i].id).length

                console.log('docProiect :>> ', docProiect);

                let cheltuieli = 0

                let costEtapa = [...getCostEtapa.Content].filter(cE => cE.id_proiect === proiecte2[i].id)


                // for (let cE = 0, n5 = costEtapa.length; cE < n5; cE++) {
                //     cheltuieli += costEtapa[cE].valoare + (costEtapa[cE].valoare * costEtapa[cE].tva / 100)
                // }


                let costTask = [...getCostTask.Content].filter(cT => cT.id_proiect === proiecte2[i].id)

                for (let cT = 0, n6 = costTask.length; cT < n6; cT++) {

                    cheltuieli += costTask[cT].valoare + (costTask[cT].valoare * costTask[cT].tva / 100)
                }


                console.log('getBugetProiect :>> ', getBugetProiect);

                // let bugetProiect = [...getBugetProiect.Content].filter(bP => bP.id_proiect === proiecte2[i].id)

                // for (let b = 0, n4 = bugetProiect.length; b < n4; b++) {
                //     buget += bugetProiect[b].valoare
                // }



                console.log('buget 1 lever :>> ', buget);

                // let bugetEtape = [...getBugetEtapa.Content]
                // bugetEtape = bugetEtape.filter(be => be.id_proiect === proiecte2[i].id)

                // for (let e = 0, n2 = bugetEtape.length; e < n2; e++) {

                //     buget += bugetEtape[e].valoare + (bugetEtape[e].valoare * bugetEtape[e].tva / 100)

                // }

                console.log('buget level 2 :>> ', buget);

                let bugetTaskuri = getBugetTask.Content
                bugetTaskuri = bugetTaskuri.filter(bt => bt.id_proiect === proiecte2[i].id)



                for (let t = 0, n3 = bugetTaskuri.length; t < n3; t++) {
                    buget += bugetTaskuri[t].valoare + (bugetTaskuri[t].valoare * bugetTaskuri[t].tva / 100)
                }

                // proiecte2[i]['buget'] = buget.toFixed(2)
                proiecte2[i]['buget'] = +(Math.round(buget + "e+3") + "e-3")
                proiecte2[i]['docs'] = docProiect
                // proiecte2[i]['cost'] = cheltuieli.toFixed(2)
                proiecte2[i]['cost'] = +(Math.round(cheltuieli + "e+3") + "e-3")


            }


            let _proiecteDrepturi = await this.ws.customSelect(`select d.*, a.id_user from angajati_departamente d left join 
            angajati a on a.id = d.id_angajat where d.id_departament in ( select id_departament from angajati_acces_departamente where id_angajat in 
               (select id from angajati where id_user = @p1) and isnull(sters,0) != 1 ) and isnull(d.inactiv,0) != 1`, {
                p1: this.ls.GetUserData().InfoUser.IdUser
            })


            let angajatiProiecte = []

            if (_proiecteDrepturi.Succes) {

                console.log('vede proiecte angajati :>> ', _proiecteDrepturi);

                for (let i = 0, n = _proiecteDrepturi.Content.length; i < n; i++) {

                    if (_proiecteDrepturi.Content[i].id_user) {

                        angajatiProiecte.push(_proiecteDrepturi.Content[i].id_user)
                    }

                }
            }



            let proiecteDrepturi = this.drepturiP.getAccesProiecte()

            for (let i = 0, n = proiecteDrepturi.length; i < n; i++) {
                let idx = proiecte2.findIndex(c => c.id === proiecteDrepturi[i].id_proiect)


                if (idx !== -1) {

                    proiecte2[idx].drepturi = proiecteDrepturi[i]

                    cloneProiecte.push(proiecte2[idx])
                }
            }


            for (let i = 0, n = cloneProiecte.length; i < n; i++) {
                cloneProiecte[i].utilizatori = cloneUseri.filter(ut => ut.id_proiect === cloneProiecte[i].id)
            }


            let drepturiProiecte = await this.drepturiP.getDrepturiAplicatie()

            if (this.ls.GetUserData().InfoUser.IsAdmin !== 1) {


                console.log('proiecte2 :>> ', proiecte2);
                console.log('angajatiProiecte :>> ', angajatiProiecte);

                angajatiProiecte.push(Number(this.ls.GetUserData().InfoUser.IdUser))

                let proiecteFilter = []




                for (let i = 0, n = cloneProiecte.length; i < n; i++) {
                    console.log('angajatiProiecte :>> ', angajatiProiecte);

                    let idxA = angajatiProiecte.indexOf(cloneProiecte[i].id_user_responsabil)

                    let idxD = cloneProiecte[i].utilizatori.findIndex(a => Number(a.id) === Number(this.ls.GetUserData().InfoUser.IdUser))

                    if (idxA !== -1) {
                        proiecteFilter.push(cloneProiecte[i])
                    } else if (idxD !== -1) {
                        proiecteFilter.push(cloneProiecte[i])
                    }
                }

                // console.log('proiecteFilter :>> ', proiecteFilter);

                cloneProiecte = proiecteFilter
            }

            this.setState({
                proiecte: cloneProiecte,
                alertView: this.drepturiAcces.getDrepturiAplicatie().acces_extins_proiecte ? false : true
            })

            console.log('proiecte2 :>> ', proiecte2);


        }
    }

    dataAzi = () => {
        let u = new Utils()

        let dataAzi = u.defaultData()

        if (this.dictionary.date === 'en') {
            return u.dataPrescurtataEng(dataAzi)
        } else {
            return u.dataPrescurtataRomana(dataAzi)
        }
    }

    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }


    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={' '} appBarButtons={this.buildAppBarButtons()} />


                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

                <Grid style={{ maxWidth: 1000, margin: 'auto' }} container>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.economic.economic} </h1>
                        <h5 style={{ textAlign: 'left', fontWeight: 400 }}>{this.dictionary.economic.selecteazaProiect} </h5>
                    </Grid>


                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>

                            {this.state.proiecte.map((p, idx) => {
                                return (
                                    <Grid onClick={() => { this.props.history.replace(`/economicdetalii/${p.id}`) }} style={{ padding: 10, cursor: 'pointer' }} key={idx} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid style={{
                                            backgroundColor: '#f1f1f1',
                                            padding: 10
                                        }} container>
                                            <Grid container>
                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <i style={{ color: 'rgb(253 189 8 )', fontSize: 35 }} className='material-icons'>folder</i>
                                                </Grid>
                                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                    <Grid container>
                                                        <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                                            <span style={{
                                                                display: 'block',
                                                                textAlign: 'left',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                fontWeight: 700
                                                            }}>{p.titlu}</span>
                                                            {/* <span style={{ display: 'block', textAlign: 'left', color: '#a4a4a4' }}>{p.docs} Documente</span> */}
                                                        </Grid>
                                                        <Grid style={{ textAlign: 'left', marginTop: 10 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                            <span style={{ display: 'block', textAlign: 'left', fontSize: 14 }}>{this.dictionary.economic.buget}: {p.buget} lei</span>
                                                            {/* <span style={{ display: 'block', textAlign: 'left', fontSize: 14 }}>{this.dictionary.economic.cheltuieli}: {p.cost} lei</span> */}
                                                        </Grid>

                                                        <Grid style={{ textAlign: 'left', marginTop: 10 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                            {/* <span style={{ display: 'block', textAlign: 'left', fontSize: 14 }}>{this.dictionary.economic.buget}: {p.buget} lei</span> */}
                                                            <span style={{ display: 'block', textAlign: 'left', fontSize: 14 }}>{this.dictionary.economic.cheltuieli}: {p.cost} lei</span>
                                                        </Grid>
                                                    </Grid>

                                                </Grid>

                                            </Grid>



                                        </Grid>
                                    </Grid>
                                )
                            })}

                        </Grid>

                    </Grid>
                    {/* {this.state.listAllDocs.map((p, idxP) => {
                        return (
                            <Grid key={idxP} container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 20, fontWeight: 500, color: 'black', marginBottom: 40 }}>
                                        {p.titlu}

                                    </h4>
                                </Grid>

                                {p.docs.map((d, idxD) => {


                                    if (p.showAllDocs) {
                                        if (d.active) {
                                            return (
                                                <Grid  key={idxD} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <Grid style={{ width: '95%', margin: 'auto', backgroundColor: 'rgb(249	249	249)', marginBottom: 20, padding: '10px', cursor:'pointer' }} container>
                                                        <Grid onClick={()=>{this.docActive(d,p)}} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                            {d.type.includes('doc') ? <img style={{ height: 50, width: 40 }} src={wordIcon} /> : <img style={{ height: 50, width: 40 }} src={pdfIcon} />}
                                                        </Grid>

                                                        <Grid onClick={()=>{this.docActive(d,p)}} style={{ textAlign: 'left', paddingLeft: 10 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                            <span style={{ fontSize: 14, fontWeight: 600 }}>{d.nume}</span><br />
                                                            <span style={{ color: 'gray', fontSize: 14 }}>{d.type.toUpperCase()}</span>
                                                        </Grid>

                                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                            <span style={{ fontSize: 14, fontWeight: 400 }}>{new Utils().dataPrescurtataRomana(d.cand_uploadat)}</span><br />
                                                            <span style={{ fontSize: 14 }}>{d.nume_t}</span>
                                                        </Grid>

                                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                            <div style={{ borderLeft: '1px solid gray', height: "100%" }}>
                                                                <div style={{ display: 'inline-block', height: 'fit-content', marginTop: '24%' }}>
                                                                    <i onClick={()=>{this.viewDoc(d,p)}} style={{ marginRight: 10 }} className='material-icons'>visibility</i>
                                                                    <i onClick={()=>{this.deleteDoc(d)}} className='material-icons'>delete</i>
                                                                </div>


                                                            </div>
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                            )
                                        } else {
                                            return (
                                                <Grid  key={idxD} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <Grid style={{ width: '95%', margin: 'auto', backgroundColor: 'rgb(249 249 249)', marginBottom: 20, padding: '10px', cursor:'pointer' }} container>
                                                        <Grid onClick={()=>{this.docActive(d,p)}} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                            {d.type.includes('doc') ? <img style={{ height: 50, width: 40 }} src={wordIcon} /> : <img style={{ height: 50, width: 40 }} src={pdfIcon} />}
                                                        </Grid>
                                                        <Grid onClick={()=>{this.docActive(d,p)}} style={{ textAlign: 'left', paddingLeft: 10 }} item xs={8} sm={8} md={8} lg={8} xl={8}>
                                                            <span style={{ fontSize: 14, fontWeight: 600 }}>{d.nume}</span><br />
                                                            <span style={{ color: 'gray', fontSize: 14 }}>{d.type.toUpperCase()}</span>
                                                        </Grid>
                                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                            <span style={{ fontSize: 14, fontWeight: 400 }}>{new Utils().dataPrescurtataRomana(d.cand_uploadat)}</span><br />
                                                            <span style={{ fontSize: 14 }}>{d.nume_t}</span>
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                            )
                                        }

                                    } else {
                                        if (idxD < 5) {

                                            if (d.active) {
                                                return (
                                                    <Grid  key={idxD} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                        <Grid  style={{ width: '95%', margin: 'auto', backgroundColor: 'rgb(249	249	249)', marginBottom: 20, padding: '10px', cursor:'pointer' }} container>
                                                            <Grid onClick={()=>{this.docActive(d,p)}} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                                {d.type.includes('doc') ? <img style={{ height: 50, width: 40 }} src={wordIcon} /> : <img style={{ height: 50, width: 40 }} src={pdfIcon} />}
                                                            </Grid>

                                                            <Grid onClick={()=>{this.docActive(d,p)}} style={{ textAlign: 'left', paddingLeft: 10 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                                <span style={{ fontSize: 14, fontWeight: 600 }}>{d.nume}</span><br />
                                                                <span style={{ color: 'gray', fontSize: 14 }}>{d.type.toUpperCase()}</span>
                                                            </Grid>

                                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span style={{ fontSize: 14, fontWeight: 400 }}>{new Utils().dataPrescurtataRomana(d.cand_uploadat)}</span><br />
                                                                <span style={{ fontSize: 14 }}>{d.nume_t}</span>
                                                            </Grid>

                                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                <div style={{ borderLeft: '1px solid gray', height: "100%" }}>
                                                                    <div style={{ display: 'inline-block', height: 'fit-content', marginTop: '24%' }}>
                                                                        <i onClick={()=>{this.viewDoc(d,p)}} style={{ marginRight: 10 }} className='material-icons'>visibility</i>
                                                                        <i onClick={()=>{this.deleteDoc(d)}}  className='material-icons'>delete</i>
                                                                    </div>


                                                                </div>
                                                            </Grid>

                                                        </Grid>
                                                    </Grid>
                                                )
                                            } else {
                                                return (
                                                    <Grid  key={idxD} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                        <Grid  style={{ width: '95%', margin: 'auto', backgroundColor: 'rgb(249 249 249)', marginBottom: 20, padding: '10px', cursor:'pointer' }} container>
                                                            <Grid onClick={()=>{this.docActive(d,p)}} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                                {d.type.includes('doc') ? <img style={{ height: 50, width: 40 }} src={wordIcon} /> : <img style={{ height: 50, width: 40 }} src={pdfIcon} />}
                                                            </Grid>
                                                            <Grid onClick={()=>{this.docActive(d,p)}} style={{ textAlign: 'left', paddingLeft: 10 }} item xs={8} sm={8} md={8} lg={8} xl={8}>
                                                                <span style={{ fontSize: 14, fontWeight: 600 }}>{d.nume}</span><br />
                                                                <span style={{ color: 'gray', fontSize: 14 }}>{d.type.toUpperCase()}</span>
                                                            </Grid>
                                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span style={{ fontSize: 14, fontWeight: 400 }}>{new Utils().dataPrescurtataRomana(d.cand_uploadat)}</span><br />
                                                                <span style={{ fontSize: 14 }}>{d.nume_t}</span>
                                                            </Grid>

                                                        </Grid>
                                                    </Grid>
                                                )
                                            }

                                        }

                                    }




                                })}


                                {p.docs.length > 5 &&
                                    <Grid item item xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span onClick={() => { this.seeAllDocs(p) }} style={{ color: 'rgb(46	105	179	)', cursor: 'pointer' }}>
                                            {!p.showAllDocs &&
                                                'Vezi toate documentele'
                                            }

                                            {p.showAllDocs &&
                                                'Vezi mai putin'
                                            }
                                        </span>
                                    </Grid>
                                }



                            </Grid>
                        )
                    })} */}
                </Grid>
                {/* <div
                    onClick={() => { this.selectFile('fileproiect') }}
                    className='container'>
                    <h1 className='pm-title'>{this.dictionary.proiecte.segmentButtons.documente}</h1>
                    <div style={{ position: this.state.fullScreen ? '' : 'absolute', top: 0, right: 30, cursor: 'pointer' }}>
                        <i style={{ display: 'block', fontSize: 40, color: '#6f9ce2' }} className='material-icons'>cloud_upload</i>
                        <span className='pm-title'>{this.dictionary.proiecte.informatiiProiect.upload}</span>

                        <input type='file' id={`fileproiect`}
                            style={{ display: 'none' }}
                            accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                            onChange={() => { this.uploadDoc(`fileproiect`, this.props.idproiect) }} />

                    </div>


                </div> */}

                {/* <Grid style={{ maxWidth: 500, margin: 'auto' }} container>
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeProiect}
                                checked={this.state.proiecteCheck} />
                            Proiecte</h3>

                    </Grid>
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeEtape}
                                checked={this.state.etapeCheck} />
                            Etape</h3>

                    </Grid>

                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeTaskuri}
                                checked={this.state.taskuriCheck} />
                            Taskuri</h3>

                    </Grid>



                </Grid> */}

                {/* 
                <Divider className='pm-divider' />
                <DocumenteList
                    elemente={this.state.listFiltered}
                    dict={this.dictionary}
                    onlyColumns={{ nume: 'nume', data: 'cand_uploadat', doc_info: 'doc_info' }}
                    goToFile={this.goToFile}
                    deleteFile={this.deleteFile}
                />

                <AlertDialog
                    open={this.state.isOpenAlert}
                    dialogClose={() => { this.setState({ isOpenAlert: false }) }}
                    title={this.dictionary.alertDate.document}
                    limba={this.dictionary}
                    yesFunction={this.deleteDoc} /> */}

            </div >
        );
    }
}